import axios from 'axios/index';
import React, {PureComponent} from 'react';

import { Classes, Overlay } from "@blueprintjs/core";


export default class ProPlanSuccessModal extends PureComponent{
    state={
        overlayIsOpen: false,
        viberEnableRequests: ''
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }
    componentDidMount(){
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }
    componentDidUpdate(){

        if (this.state.overlayIsOpen !== this.props.showModal){
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
    }
    render(){
        return(
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER} isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field" style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <p className="modal-close-button" onClick={ () =>{this.props.handleClose()} }><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel">
                        <h1 className="m-m-b text-align-center">Thank You</h1>
                        <div className="form-group m-m-b">
                            <p className='text-align-center'><strong>You have successfully subscribed to Emitto Pro Plan</strong></p>
                            <p className='text-align-center'>Enjoy in your premium features.</p>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <button
                                disabled={ false }
                                onClick={ this.props.handleClose }
                                name="cancel_delete_tag"
                                id="cancel_delete_tag"
                                type="button"
                                className="btn btn-action btn-sm m-sm-b center">Next</button>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}